import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=042b36a3"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports